import CLPUserLabelStore from './schema/CLPUserLabelStore';
import { createStore } from 'satcheljs';

const CLPUserLabelData: CLPUserLabelStore = {
    userLabels: [],
    learnMoreUrl: '',
};

export { default as CLPUserLabelStore } from './schema/CLPUserLabelStore';
export const getStore = createStore<CLPUserLabelStore>('CLPUserLabels', CLPUserLabelData);
export default getStore();
